<app-cheating-analysis [item]="item" ></app-cheating-analysis>

<app-applicant-step-language-score-avg [item]="item"></app-applicant-step-language-score-avg>

<app-applicant-step-score-info-language [item]="item" (onFilterItems)="filterItems($event)"></app-applicant-step-score-info-language>

<app-applicant-step-question-list-language (sendAverageRating)="updateAverageSteps()" [originalList]="originalList" [applicationId]="applicationId" [item]="item" [applicantId]="applicantId" [filteredList]="filteredList" [cheatingQuestionLog]="cheatingQuestionLog"></app-applicant-step-question-list-language>
